import * as React from 'react';
import { AxiosResponse } from 'axios';
import APIManager from '../../../utilities/api-manager';
import Loader from '../../_common/loader';

function SnippetProvider<T>(props: SnippetProviderProps<T>) {
    const { docKey, parser, isSecured, initialData, render, loaderMinHeight } = props;
    const [snippet, setSnippet] = React.useState<T>();

    React.useEffect(() => {
        setSnippet(initialData);
        if (isSecured || isSecured === undefined) {
            APIManager.getS3HtmlDocByKey(docKey).then((response: AxiosResponse) => {
                if (response.data) {
                    setSnippet(parser ? parser(response.data) : response.data);
                }
            });
        }
    }, [docKey]);

    return snippet ? render(snippet) : <Loader minHeight={loaderMinHeight || ''} />;
}

export default SnippetProvider;
